module.exports = __webpack_public_path__ + "static/media/About.0cb59fee.png";